// @flow
import {EXPANDED_SEARCH_GROUPS_EXPAND_GROUP} from '../actions/expandedSearchGroups';
import {SEARCH_QUERY_COMPLETE} from '../actions/searchQuery';
import type {Action as ExpandedSearchGroupAction} from '../actions/expandedSearchGroups';
import type {Action as SearchQueryAction} from '../actions/searchQuery';

export type State = {
    +openGroupIndexes: number[],
    +hasModifiedMapViewport: boolean
};

export const INITIAL_STATE: State = {
    openGroupIndexes: [],
    hasModifiedMapViewport: false
};

export default function reducer(
    state: State = INITIAL_STATE,
    action: ExpandedSearchGroupAction | SearchQueryAction
): State {
    switch (action.type) {
        case EXPANDED_SEARCH_GROUPS_EXPAND_GROUP:
            return {
                ...state,
                openGroupIndexes: [
                    ...state.openGroupIndexes,
                    action.payload.index
                ],
                hasModifiedMapViewport: !!action.payload.hasModifiedMapViewport
            };
        case SEARCH_QUERY_COMPLETE:
            return {
                ...state,
                openGroupIndexes: [...INITIAL_STATE.openGroupIndexes],
                hasModifiedMapViewport: false
            };
        default:
            // Ensures we have handled every single action type
            // by casting the action to `empty` in the default case.
            // If Flow finds it possible to reach this case, the empty
            // cast will fail.
            (action: empty); // eslint-disable-line no-unused-expressions
            return state;
    }
}
